import { render, staticRenderFns } from "./AnnouncementIndex.vue?vue&type=template&id=97f4e550&scoped=true&"
import script from "./AnnouncementIndex.vue?vue&type=script&lang=js&"
export * from "./AnnouncementIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f4e550",
  null
  
)

export default component.exports